import { connect } from 'react-redux';
import { searchFriendsWithOptions } from '../redux/users/actionCreators';
const mapDispatchToProps = {
    onSearch: searchFriendsWithOptions
};
export default connect(null, mapDispatchToProps, null, {
    forwardRef: true
});

//# sourceMappingURL=UserSearchField.container.js.map